import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'booleanTransformIcon'
})
export class BooleanTransformIconPipe implements PipeTransform {

  constructor(private _domSanitizer: DomSanitizer) { }
  transform(value?: boolean): string {
    let iconTag: string = '<span></span>'

    if (value == null)
      return this._domSanitizer.sanitize(SecurityContext.HTML, iconTag);

    if (!!value) {
      iconTag = '<i class="fas fa-check" aria-hidden="true"></i><span class="sr-only">Yes</span>'
    } else {
      iconTag = '<i class="far fa-window-close fa-lg text-danger" aria-hidden="true"></i><span class="sr-only">No</span>'
    }

    return this._domSanitizer.sanitize(SecurityContext.HTML, iconTag);
  }

}
